console.log('[Fabrikator Debug] Script loaded');

document.addEventListener("variant:changed", function (evt) {
  console.log('[Fabrikator Debug] variant:changed event fired, variant ID:', evt.detail.variant.id);
  
  // Find Fabrikator's hidden list
  const variantsList = document.querySelector('.fabrikator__variants-metafields');
  const shipmentText = document.querySelector('.fabrikator__shipment-text');
  
  if (!variantsList || !shipmentText) {
    console.log('[Fabrikator Debug] Fabrikator elements not found');
    return;
  }
  
  // Look for the variant in the list
  const variantItem = variantsList.querySelector(`li[data-variant-id="${evt.detail.variant.id}"]`);
  
  if (variantItem) {
    // Variant has backorder - show message with date
    const backorderDate = variantItem.textContent.trim();
    const dateSpan = shipmentText.querySelector('span');
    
    if (dateSpan) {
      dateSpan.textContent = backorderDate;
    }
    
    shipmentText.style.display = 'block';
    console.log('[Fabrikator Debug] Showing backorder message for variant:', evt.detail.variant.id, 'Date:', backorderDate);
  } else {
    // Variant doesn't have backorder - hide message
    shipmentText.style.display = 'none';
    console.log('[Fabrikator Debug] Hiding backorder message for variant:', evt.detail.variant.id);
  }
});
